export default {
    GET_QUESTIONS_REQUEST: 'SCENARIO_EVALUATION_TEMPLATE_PREVIEW_GET_QUESTIONS_REQUEST',
    GET_QUESTIONS_SUCCESS: 'SCENARIO_EVALUATION_TEMPLATE_PREVIEW_GET_QUESTIONS_SUCCESS',
    DISPOSE: 'SCENARIO_EVALUATION_TEMPLATE_PREVIEW_DISPOSE_STORE',
};
